import { useAttributeLabelTranslator } from '@/components/datamodel/hooks/useAttributeLabelTranslator';
import { useDataModel } from '@/hooks/useDataModel';

const DynamicEntryHeader = ({ attributeName }: { attributeName: string }) => {

    const { dataModel } = useDataModel();
    const { translateAttributeLabel } = useAttributeLabelTranslator();
    const attribute = dataModel?.attribute(attributeName);

    if (!attribute) {
        return attributeName;
    } else {
        return <span>{translateAttributeLabel(attribute)}</span>;
    }

};

export { DynamicEntryHeader };
